import type { HotelNotificationSetting } from "@/lib/gql/__generated__/graphql";

import type { AutoGeneratorForFormModel } from "@/components/features/_model";

import type { HotelNotificationSettingInputZodSchemaType } from "./validation-schema";

const _excludeKeys = ["hotelID"] as const;
export const excludeKeys = _excludeKeys.map((key) => key);
export type ExcludeKeys = (typeof excludeKeys)[number];

export type HotelNotificationSettingFormModel = AutoGeneratorForFormModel<
	HotelNotificationSettingInputZodSchemaType,
	ExcludeKeys,
	HotelNotificationSetting
>;
